import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.simpleInput('text', 'First Name', null, 'firstName', true, 6),
      helper.simpleInput('text', 'Last Name', null, 'lastName', true, 6),
      helper.ssn('SSN', 'ssn', null, false, 6),
    ],
  },
  options: helper.options('contact-basic-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/contact/schemas/plaid.js